// components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // if (loading) {
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;